<div class="container mt-2 mb-0">
  <div class="row justify-content-center my-4">
    <div class="col-12 col-md-8">
      <div class="row rounded pb-3">

        @if(loading()) {
          <mat-progress-spinner
            color="primary"
            mode="indeterminate"
          >
          </mat-progress-spinner>
        }
        @else {
          @if(cartError()) {
            <div class="error-section">Error: {{cartError()}}</div>
          }    
          @if(cartCompleted()) {
            <div>This cart is already paid</div>
          }
          @if(!cartError() && !cartCompleted()) {
            <equine-ui-nx-order-summary
              [subtotal]="subTotal()"
              [subtotalCount]="totalItems()"
              [coupon]="coupon()"
              [donation]="donationOrderTotal()"
              [total]="total()"
              (goBack)="goBack()"
            ></equine-ui-nx-order-summary>
          }
        }
      </div>
    </div>

    <div class="col-12 col-md-4">
      <mat-card class="p-0 shadow">
        <mat-card-header>
          <mat-card-title class="card-title">Proceed to Payment</mat-card-title>
        </mat-card-header>
        <hr>
        
        <div class="row justify-content-center my-4">
          <div class="col-md-10">
            @if(paypalLoading()) {
              <div class="spinner-container">
                <mat-progress-spinner
                  mode="indeterminate"
                  class="spinner"
                  diameter="30"
                >
                </mat-progress-spinner>
              </div>
            }
            <div id="paypalButtons"></div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>

</div>